import { ruleMessage } from '@cnamts/vue-dot/src//helpers/ruleMessage';
import { ErrorMessages } from '@cnamts/vue-dot/src/rules/types';
import { getFileExtension } from '@cnamts/vue-dot/src/functions/getFileExtension';

const defaultErrorMessages: ErrorMessages<string> = {
	default: (accepted: string) => `Format de fichier incorrect, les formats acceptés sont ${accepted}`
};

/** Check that the file does not exceeds the max size in byte */
export function fileAccept(accept: string[], errorMessages = defaultErrorMessages) {
	// Return the validation function
	return (value: File) => {
		// If the value is empty, return true (valid)
		if (!value || (Array.isArray(value) && !value.length)) {
			return true;
		}

		const fileExt = getFileExtension(value.name);

		const accepted = accept.join(', ');

		return accept.includes(fileExt) || ruleMessage(errorMessages, 'default', [accepted]);
	};
}

export default fileAccept;
